export default __webpack_public_path__ + "static/Lenses-619a9659e634758cede6d8698df86bc7.png";